module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"utilityHeader":"Elektrizitätsversorgung und Preise","noGisData":"Keine Daten verfügbar"}}')
  delete Component.options._Ctor
}
